//Drag Word is a variant of H5P's DragQuestion.
//This interactive allows the user to drag answers into dropzones next to questions.
//Also referred to as Drag the Word.
import Container from './container'
export default Container
